export default "__VITE_ASSET__6f79142b__"